import { SearchQuery } from '../models/search-query.model';
import { LocalStorageUtility } from '../utilities/localStorage.utility';

export class SearchQueryService {
  private storage = new LocalStorageUtility();

  public setSearchQuery(searchQuery: any): void {
    this.storage.set('searchQuery', searchQuery);
  }

  public getSearchQuery(): SearchQuery {
    return new SearchQuery(this.storage.get('searchQuery'));
  }
}
